<template>
  <v-card>
    <v-card-title :class="selClass">
      <v-icon class="mr-5">mdi-calendar-month</v-icon>
      <span class="timeline-date mr-5">{{rec.created | dt-sec}}</span>
      <span class="ml-2" v-if="rec.status==201">{{$t('status.201')+' #'+rec.amount2}}</span>
      <span class="ml-2" v-if="rec.status==202">{{$t('status.202')}}</span>
      <span class="ml-2" v-if="rec.status==200 && rec.amount1!=0">{{$t('card.legend.purchase.1')}}</span>
      <span class="ml-2" v-if="rec.status==200 && rec.amount2!=0">{{$t('card.legend.sell.1')}}</span>
      <v-spacer></v-spacer>
      <span class="tl-amount idcs-data-back" v-if="rec.amount1">{{rec.amount1 | currency}}</span>
      <span class="tl-amount idcs-data-back" v-else-if="rec.amount2 && rec.status!=201">{{rec.amount2 | currency}}</span>
    </v-card-title>
    <v-card-text class="idcs-data-back">
      <v-layout row fluid class="pt-4">
        <v-flex xs12 sm12 md3 lg2 xl2 class="pl-3 text-capitalize">{{$t('field.terminal')}}</v-flex>
        <v-flex xs12 sm12 md5 lg6 xl6 class="subtitle-2 font-weight-medium">
          <v-icon small class="mr-2">fa-cash-register</v-icon>
          {{rec.terminal}}
        </v-flex>
        <v-flex
          xs12
          sm12
          md4
          lg4
          xl4
          class="pr-3 subtitle-2 font-weight-medium text-right"
        >{{$t('card.receipt')+" #"+rec.rec_nr}}</v-flex>
        <v-flex xs12 sm12 md3 lg2 xl2 class="pl-3 text-capitalize mt-2">{{$t('field.subcompany')}}</v-flex>
        <v-flex xs12 sm12 md9 lg10 xl10 class="subtitle-2 mt-2 font-weight-black">
          <v-icon small class="mr-2">fa-store</v-icon>
          {{rec.subcompany}}
        </v-flex>
      </v-layout>
      <!--<div>{{JSON.stringify(rec)}}</div>!-->
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TransTimeLineCard1",
  props: {
    record: { type: Object, required: true }
    // colorMinus: { type: String, default: "#BBDEFB" },
    // colorPlus: { type: String, default: "#C8E6C9" }
  },
  computed: {
    rec() {
      return this.record;
    },
    // tlColor() {
    //   if (this.record.status == 200) {
    //     return this.record.amount2 ? this.colorPlus : this.colorMinus;
    //   }
    //   return "#E0E0E0";
    // },
    selClass() {
      if (this.record.status == 200 && this.record.amount1 > 0)
        return "idcs-t-sell";
      if (this.record.status == 200 && this.record.amount2 > 0)
        return "idcs-t-buy";
      if (this.record.status == 201) return "idcs-t-canceled";
      if (this.record.status == 202) return "idcs-t-reversal";
      return "";
    }
  }
};
</script>

<style scoped>
.timeline-date {
  font-size: medium;
}
/*.tl-card-text {
  background-color: cornsilk;
}*/
.tl-amount {
  /*  background-color: cornsilk;*/
  border-radius: 8px;
  font-size: x-large;
  padding-left: 8px;
  padding-right: 8px;
}
</style>